import {sharePage} from '../../utils/index'
// 分享模块的一些行为
export default {
  state: {
    show: false
  },

  actions: {
    showShare ({state}) {
      state.show = true
    },

    hideShare ({state}) {
      state.show = false
    },

    appSharePage ({rootState}, type) {
      var shareInfo = {
        title: rootState.header.shareInfo.title,
        titleUrl: rootState.header.shareInfo.titleUrl,
        content: rootState.header.shareInfo.content,
        imageUrl: rootState.header.shareInfo.imageUrl,
        shareType: type
      }
      sharePage(shareInfo)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/share.js